<template>
    <div>
        <Loader :show="loading"></Loader>
        <template v-if="!loading">
            <Breadcrumb style="position: relative;margin:0;"></Breadcrumb>
            <div class="info-wrapper default">
                <div
                    class="detail-img-wrapper mb-3"
                    v-for="(photoId, index) in detail.listPhotos"
                    :key="photoId"
                >
                    <vue-load-image>
                        <img
                            slot="image"
                            :src="`${apiPhotoUrl}/ori/${photoId}`"
                            :alt="detail.name + index"
                        />
                        <img
                            slot="preloader"
                            src="@/assets/image-loader.gif"
                            class="w-100"
                        />
                        <img
                            slot="error"
                            class="border d-block"
                            src=""
                            alt="not found"
                        />
                    </vue-load-image>
                </div>
                <div class="detail-card green">
                    <div class="card-body">
                        <div
                            class="title mb-2"
                            v-text="detail.name"
                        >
                            林之助紀念館
                        </div>
                        <p
                            class="html-wrapper"
                            v-html="detail.description"
                        >
                            林之助紀念館原為林之助故居（居住宿舍），興建於1928年，為日治時期木造宿舍典型建築。除保留當時構造原貌，也見證柳川沿岸都市的發展，同時記錄了林之助一生之創作與歷程。2007年臺中市以「林之助畫室」之名登錄為歷史建築，2013年由國立臺中教育大學進行修復再利用計畫，2015年修繕保存後免費開放參觀。<br /><br />
                            林之助紀念館創建於1928年，前身為臺中師範學校附屬之教師宿舍，亦為膠彩畫之父林之助教授的故居，除保留當時建築構造原貌，也見證柳川沿岸都市的發展，同時記錄了林之助教授一生之教學與創作歷程。2015年修復落成後免費開放參觀，現由國立臺中教育大學自籌經費管理營運。
                        </p>
                        <div class="title mb-2">開放時間</div>
                        <p
                            class="html-wrapper"
                            v-html="detail.openingHours"
                        >
                            周三至周日，11:00-17:00
                        </p>
                        <div class="title mb-2">地址</div>
                        <p
                            class="html-wrapper"
                            v-text="detail.address"
                        >
                            台中市西區柳川西路二段158號
                        </p>
                        <audio
                            controls
                            ref="audio"
                            class="d-none"
                        >
                            <source
                                :src="
                                    `${urls.audio}?id=${detail.id}&audioType=${
                                        detail.attractionType === 2 ? 2 : 1
                                    }`
                                "
                                type="audio/mpeg"
                            />
                            Your browser does not support the audio element.
                        </audio>
                        <button
                            class="btn btn-more  w-100 d-block my-3 audio-tour-btn"
                            @click="playAudio"
                        >
                            語音導覽
                            <div
                                class="overlay"
                                v-show="playing"
                            >
                                <div class="svg-wrapper">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 320 512"
                                        style="fill:#000;width:1.177rem;height:1.177rem;"
                                    >
                                        <path d="M272 63.1l-32 0c-26.51 0-48 21.49-48 47.1v288c0 26.51 21.49 48 48 48L272 448c26.51 0 48-21.49 48-48v-288C320 85.49 298.5 63.1 272 63.1zM80 63.1l-32 0c-26.51 0-48 21.49-48 48v288C0 426.5 21.49 448 48 448l32 0c26.51 0 48-21.49 48-48v-288C128 85.49 106.5 63.1 80 63.1z" />
                                    </svg>
                                </div>
                            </div>
                        </button>
                        <button
                            class="btn btn-more w-100 d-block my-3"
                            @click="goGoogleMap([detail.lon, detail.lat])"
                        >
                            如何抵達
                        </button>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex';
import Breadcrumb from '@/components/Breadcrumb';
import coreMixin from '@/js/mixin/coreMixin';
import Loader from '@/components/Loader';
import { apiAttractionDetail } from '@/plugin/api';
import { GET_AUDIO } from '@/plugin/api/constants';

export default {
    data() {
        return {
            loading: false,
            detail: {},
            urls: {
                audio:
                    (process.env.NODE_ENV === 'development'
                        ? ''
                        : process.env.VUE_APP_API) + GET_AUDIO,
            },
            playing: false,
        };
    },
    mounted() {
        this.getDetail();
        this.initAudio();
    },

    computed: {
        ...mapState('userData', ['currentPosition']),
        ...mapGetters('userData', ['isInValidScope']),
    },
    methods: {
        ...mapActions('userData', ['setSpotPosition']),
        async getDetail() {
            const { id } = this.$route.params;
            this.loading = true;
            await apiAttractionDetail(id).then((res) => {
                if (res.data.success) {
                    this.detail = {
                        ...res.data.data,
                        lat: +res.data.data.latitude,
                        lon: +res.data.data.longitude,
                        name: res.data.data.name,
                        id: res.data.data.attractionId,
                    };
                    this.setSpotPosition([this.detail.lon, this.detail.lat]);
                    const { breadcrumb } = this.$route.meta;
                    breadcrumb[breadcrumb.length - 1].name = this.detail.name;
                }
            }, this.errorHandler);
            this.loading = false;
        },
        initAudio() {
            this.$refs.audio.addEventListener('canplay', () => {
                if (this.$refs.audio) {
                    this.$refs.audio.removeEventListener(
                        'ended',
                        this.stopPlaying,
                    );
                    this.$refs.audio.addEventListener(
                        'ended',
                        this.stopPlaying,
                    );
                    this.$refs.audio.removeEventListener(
                        'paused',
                        this.stopPlaying,
                    );
                    this.$refs.audio.addEventListener(
                        'paused',
                        this.stopPlaying,
                    );
                }
            });
        },
        playAudio() {
            if (this.$refs.audio.paused) {
                this.$refs.audio.play();
                this.playing = true;
            } else {
                this.$refs.audio.pause();
                this.playing = false;
            }
        },
        stopPlaying() {
            this.playing = false;
        },
    },
    components: {
        Breadcrumb,
        Loader,
    },
    mixins: [coreMixin],
};
</script>

<style></style>
